import { userInfo, getBalance } from '@/apis/modules/home.js';
import store from '@/store';
import { Toast } from 'vant';
let $uStore = [];
try {
  $uStore = store.state;
} catch (e) { }

const getBalanceFun = () => {
  getBalance({
    withdraw: 1
  }).then(({ code, msg, data }) => {
    if (code > 0 && store.state.moneyInfo.balance_total_str) {
      Toast.fail({
        message: msg,
        duration: 1000
      });
      return;
    }
    if (!store.state.moneyInfo.balance_total_str) {
      data = {
        balance_coin: '0.00',
        balance_bonus: '0.00',
        recharge_total: 0,
        balance_total: '0,00',
        balance_total_str: '0,00',
        balance_coin_str: '0,00',
        balance_bonus_str: '0,00',
        have_message: 0,
        credit_score: 100,
        withdraw: {
          max_withdraw: 50000,
          water_limit: '0.00',
          mix_withdraw: 10,
          min_withdraw_bonus: 10,
          water_limit_str: '0,00',
          bank: null
        }
      };
    }
    store.commit('publicFun', ['moneyInfo', data]);
  });
};

export default {
  getBalance: getBalanceFun,
  btn_zc2_2: require('./../assets/icons/active/btn_zc2_2.webp'),
  btn_zc2_1: require('./../assets/icons/active/btn_zc2_1.webp'),
  _vuex_token: () => {
    return $uStore.vuex_token || false;
  },
  animate: e => {
    let target = e.target;
    let tagName = target.tagName.toLowerCase();
    if (tagName == 'svg') {
      getBalanceFun();
      target.classList.add('animate__manimated');
      let time = setTimeout(() => {
        clearTimeout(time);
        target.classList.remove('animate__manimated');
      }, 300);
    }
  }
};
